/* eslint-disable no-use-before-define */
import React, { useState } from "react"
import CheckoutContext from "./checkout-context"
import { graphql, useStaticQuery } from "gatsby"

// The backend can return a gateway as a plain code string, a JSON string, or a
// {paymentCode, label, description} object. Always hand the UI the object form.
export const normalisePaymentGateway = (gateway) => {
  if (typeof gateway === "string") {
    try {
      const parsed = JSON.parse(gateway)
      if (parsed && typeof parsed === "object") return parsed
    } catch {}
    return { paymentCode: gateway, label: gateway, description: "" }
  }
  return gateway
}

// =====================
// 	  Checkout Context
// =====================
const CheckoutProvider = ({ children }) => {
  // Available payment options to choose from
  const paymentGatewayData = useStaticQuery(PAYMENT_GATEWAY_QUERY)
  const paymentOptions = (
    paymentGatewayData?.seaSiteInfo?.payment_gateways || []
  ).map(normalisePaymentGateway)

  // Global selected payment methods
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    paymentOptions[0]
  )
  const [availableProvinces, setAvailableProvinces] = useState([])
  const [selectedProvince, setSelectedProvince] = useState("None")
  const [availableBranches, setAvailableBranches] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(0)

  return (
    <CheckoutContext.Provider
      value={{
        paymentOptions,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        selectedBranch,
        setSelectedBranch,
        availableBranches,
        setAvailableBranches,
        availableProvinces,
        setAvailableProvinces,
        selectedProvince,
        setSelectedProvince,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  )
}

export default CheckoutProvider

// ===============
//      QUERY
// ===============

const PAYMENT_GATEWAY_QUERY = graphql`
  {
    seaSiteInfo {
      payment_gateways
    }
  }
`
